/*
 *
 * TermsCheckBox
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 31-Jan-2025
 */

import { connect } from 'react-redux'
import TermsCheckBox from './TermCheckBox'
import { doPopup } from 'Store/actions/popup'

const mapDispatchToProps = (dispatch) => ({
  openTermsAndConditionsDisputlessPopup: () => dispatch(doPopup('TERMS_AND_CONDITIONS_DISPUTLESS_POPUP'))
})

const mapStateToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(TermsCheckBox)
